import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "@/utils/axiosInstance";
import { handleThunkError } from "@/utils/thunkErrorHandler";
import { Params } from "@/types";

const endpoint = {
  categories: "/categories",
};

export const fetchCategory = createAsyncThunk(
  "categories/fetchCategory",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.categories, { params });
      return response.data;
    } catch (error) {
      return handleThunkError(error, thunkAPI, "Erro ao carregar categorias");
    }
  },
);

// Criar categoria (apenas com nome)
export const createCategory = createAsyncThunk(
  "categories/createCategory",
  async (data: { name: string }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(endpoint.categories, data);
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Não foi possível cadastrar a categoria",
      );
    }
  },
);

// Atualizar categoria (apenas nome, via slug ou id se necessário)
export const updateCategory = createAsyncThunk(
  "categories/updateCategory",
  async (
    data: { slug: string; name: string; model_type: string },
    thunkAPI,
  ) => {
    try {
      const response = await axiosInstance.put(
        `${endpoint.categories}/${data.slug}`,
        { name: data.name, model_type: data.model_type },
      );
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Não foi possível atualizar a categoria",
      );
    }
  },
);

// Deletar categoria
export const deleteCategory = createAsyncThunk(
  "categories/deleteCategory",
  async (slug: string, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(
        `${endpoint.categories}/${slug}`,
      );
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Não foi possível excluir a categoria",
      );
    }
  },
);
